import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import Table from 'src/components/Table';
import { useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { LOAD_CONTRACT_FISCAL_INTEREST_BALANCE } from 'src/store/actions/contractActions';
import InterestBalanceScheduleRow from './InterestBalanceScheduleRow';

const Tbody = ({ interestBalanceSchedule }) =>
  (interestBalanceSchedule).map((item, index) => (
    <InterestBalanceScheduleRow key={item.id || index} {...item} />
  ));

const InterestBalanceScheduleTable = ({
  className,
  interestBalanceSchedule,
  ...rest
}) => {
  const { t } = useTranslation();

  const loading = useSelector(
    isLoadingSelector([LOAD_CONTRACT_FISCAL_INTEREST_BALANCE.action])
  );

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" align="center">
          {t('CONTRACT_VIEW.CONTRACT_DETAIL.PERIOD')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('COMMON.DATE')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('INTEREST_BALANCE.INITIAL_BALANCE')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('INTEREST_BALANCE.SUBSCRIPTION')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('CONTRACT_VIEW.CONTRACT_DETAIL.INTEREST')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('INTEREST_BALANCE.FINAL_BALANCE')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => (
      <Tbody interestBalanceSchedule={interestBalanceSchedule} />
    ),
    [interestBalanceSchedule]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      loading={loading}
    />
  );
};

InterestBalanceScheduleTable.propTypes = {
  className: PropTypes.string,
  interestBalanceSchedule: PropTypes.array.isRequired
};

export default InterestBalanceScheduleTable;

